import type {EagGridState} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export const selectIsGridMaximized = (state: EagGridState) => state.isMaximized;

export const useIsGridMaximized = () => useEagGridSelector(selectIsGridMaximized);
